// controllers
import ResizeController from '../../assets/js/controllers/resize';

// helpers
import { getRootOffsetBounds, validateParamBoolean, validateParamNumber } from '../../assets/js/helpers';

// usage
// items may have the following attributes:

// [data-item-delay]			accepts a numerical value

export default class TransitionDelay {

	static selector = '[data-trans-delay]';

	// class variables

	config = {
		isMobileEnabled: false
	};

	el = {};

	defaults = {
		delay: 0.08
	};

	controllers = {
		resize: null
	};

	states = {
		orderedItems: []
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			items: container.querySelectorAll('[data-trans-delay-item]')
		};

		this.config = { ...this.defaults };

		// check for custom stagger delay time
		this.config.delay = validateParamNumber(this.el.container, 'data-trans-delay', this.defaults.delay);
		this.config.isMobileEnabled = validateParamBoolean(this.el.container, 'data-parallax-mobile');

		// intialize
		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		this.measure();
		this.adjust();
	}

	// event listeners

	#addEventListeners = () => {
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		ResizeController.clear(this.controllers.resize);
	}

	// controller methods

	#onResizeUpdate = () => {
		this.measure();
		return true;
	}

	#onResizeRender = () => {
		if (this.states.index >= 0) {
			const $target = this.el.targets[this.states.index];
			const $targetContent = $target.children[0];
			this.setExpandHeight($target, $targetContent.offsetHeight);
		}
	}

	//

	measure() {
		const orderedItems = [];
		for (let i = 0; i < this.el.items.length; i++) {
			const $item = this.el.items[i];
			const itemBounds = getRootOffsetBounds($item);

			let delay = parseFloat($item.getAttribute('data-trans-delay-item'));
			delay = isNaN(delay) ? this.config.delay : delay;

			orderedItems.push({ $item, itemBounds, delay });
		}

		this.states.orderedItems = orderedItems.sort((a, b) => a.itemBounds.top - b.itemBounds.top);

		return !!this.states.orderedItems.length;
	}

	adjust() {
		let delayAccumulated = 0;
		for (let i = 0; i < this.states.orderedItems.length; i++) {
			const orderedItem = this.states.orderedItems[i];
			delayAccumulated += orderedItem.delay;
			orderedItem.$item.style.transitionDelay = `${delayAccumulated}s`;
		}

	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
